import { useState } from "react";
import { FileDownload, FileUpload } from "@mui/icons-material";
import * as xlsx from "xlsx";
import SampleInputFile from "../../assets/InputFileforScienceFairJudgeAssignments.xlsx";
import API from "../../utils/api";
import "./HomePage.css";
import {
  AppBar,
  Box,
  Button,
  Container,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  OUTPUT_SUCCESS_MESSAGE,
  OUTPUT_ERROR_MESSAGE,
  REQUEST_STATUS,
  FILE_NAME,
} from "../../constants/index";

export default function MarketMapExcel(props) {
  const [outputJson, setOutputJson] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [requestStatus, setRequestStatus] = useState(REQUEST_STATUS.INITIAL);
  const [uploadFile, setUploadFile] = useState("");

  const readUploadFile = (e) => {
    setRequestStatus(REQUEST_STATUS.IN_PROGRESS);
    e.preventDefault();
    if (e.target.files) {
      setUploadFile(e.target.files[0].name);
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetsjson = {};
        workbook.SheetNames.forEach((sheetName) => {
          const worksheet = workbook.Sheets[sheetName];
          sheetsjson[sheetName] = xlsx.utils.sheet_to_json(worksheet, {
            defval: "",
          });
        });
        const sanitizedJson = sanitize(sheetsjson);
        generateAllocation(sanitizedJson); // this is the function that calls the API - uncomment when be ready
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const sanitize = (sheetsjson) => {
    for (const sheet in sheetsjson) {
      const sheetData = sheetsjson[sheet];
      for (let i = 0; i < sheetData.length; i++) {
        const row = sheetData[i];
        for (const column in row) {
          if (column.includes("__EMPTY")) {
            delete row[column];
          }
        }
      }
    }
    return sheetsjson;
  };

  const generateAllocation = (sanitizedJson) => {
    const ENDPOINT = "/generate";
    const METHOD = "POST";
    const BODY = sanitizedJson;
    setOutputJson({});
    setIsLoading(true);
    API(ENDPOINT, METHOD, BODY)
      .then((data) => {
        setOutputJson(data);
        console.log("Output from API", data);
        setRequestStatus(REQUEST_STATUS.SUCCESS);
      })
      .catch((err) => {
        setRequestStatus(REQUEST_STATUS.ERROR);
        console.log("Error from API", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const jsonToExcel = () => {
    for (const [worksheetName, workSheetValue] of Object.entries(outputJson)) {
      const workbook = xlsx.utils.book_new();
      const excelData = xlsx.utils.json_to_sheet(workSheetValue);
      xlsx.utils.book_append_sheet(workbook, excelData, worksheetName);
      xlsx.writeFile(workbook, `${FILE_NAME[worksheetName]}`);
    }
  };

  return (
    <>
      <AppBar position="static" color="transparent">
        <Box
          flexDirection={"row"}
          display={"flex"}
          width="100%"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box className="Image-icon">
            <img
              src={require("../../assets/logo.jpeg")}
              className="App-logo"
              alt="logo"
            />
          </Box>
          <h1>Assign Judges to Projects</h1>
        </Box>
      </AppBar>

      <Container className="Page-Content">
        <Box className="Section">
          <Typography>Sample Input Excel File for Regional Chairs.</Typography>
          <Typography>Download and edit the data for Your Region.</Typography>

          <Button variant="contained" endIcon={<FileDownload />}>
            {" "}
            <a
              href={SampleInputFile}
              download="Input File for Science Fair Judge Assignments"
            >
              Download
            </a>
          </Button>
        </Box>
        <Box className="Section">
          <Typography>
            Upload the Input Excel File to optimally assign Judges to Projects.
          </Typography>
          <Box
            flexDirection="row"
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Button
              variant="contained"
              endIcon={<FileUpload />}
              disabled={isLoading}
              component="label"
            >
              Upload
              <input
                type="file"
                hidden
                onChange={readUploadFile}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </Button>
            <Typography sx={{ textDecoration: "underline" }}>
              {uploadFile}
            </Typography>
          </Box>
        </Box>

        <Box className="Section Last">
          {isLoading && <CircularProgress />}
          {(requestStatus === REQUEST_STATUS.SUCCESS ||
            requestStatus === REQUEST_STATUS.ERROR) && (
            <>
              <Typography>
                {requestStatus === REQUEST_STATUS.SUCCESS
                  ? `${OUTPUT_SUCCESS_MESSAGE}`
                  : `${OUTPUT_ERROR_MESSAGE}`}
              </Typography>
              {requestStatus === REQUEST_STATUS.SUCCESS && (
                <Button
                  variant="contained"
                  endIcon={<FileDownload />}
                  disabled={isLoading}
                  onClick={jsonToExcel}
                >
                  Download
                </Button>
              )}
            </>
          )}
        </Box>
      </Container>
    </>
  );
}
